import { Option } from '../common/OptionInput';
import e2af_en from "../../../../../assets/images/LinkOption/e2af_en.png";
import e2af_es from "../../../../../assets/images/LinkOption/e2af_es.png";
import e2af_fr from "../../../../../assets/images/LinkOption/e2af_fr.png";
import { useContext } from 'react';
import { LocalesContext } from '../../../../../context/localesContext';

const e2af = {
  "en": e2af_en,
  "es": e2af_es,
  "fr": e2af_fr
}

const UseSocial = ({ useSocial, useSocialChange }) => {
  return (
    <div className="col-sm-4">
      <label htmlFor="use_social" className="checkbox-label">Use social</label>
      <input
        key={Math.random()}
        onChange={useSocialChange}
        checked={useSocial == true}
        value="use_social"
        type="checkbox"
        id="use_social"
        name="use_social"
      />
    </div>
  )
}

export const Email2AFriend = ({ useSocial, setUseSocial, onTypeChange, type }) => {
  const { currentLocale } = useContext(LocalesContext);

  const useSocialChange = (e) => {
    setUseSocial(e.target.checked)
  };

  return (
    <>
      <Option
        id="email"
        checked={type}
        onChange={onTypeChange}
        text="Link an email to a friend form (click to preview)"
        value="e2af"
        name="link"
      />
      {type == "e2af" &&
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "15px"
          }}
        >
          <UseSocial useSocial={useSocial} useSocialChange={useSocialChange} />
          <img
            style={{
              marginTop: "20px",
              position: "relative",
              width: "300px",
              height: "auto",
            }}
            className={`e2af ${useSocial ? "social" : ""}`}
            src={e2af[currentLocale]}
          />

        </div>
      }
    </>
  )
}